<template>
  <div>
    <v-card color="transparent" class="text-left mb-3" elevation="0">
      <v-btn @click="$router.go(-1)" color="transparent" dark elevation="0">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
    </v-card>
    <v-card>
      <v-alert
        class="text-left"
        dense
        border="left"
        type="warning"
        v-if="!paymentMethodAdded"
      >
        To book an appointment or purchase a package, you need to add a payment
        method. Please click
        <v-btn x-small color="white" light depressed rounded to="/add-payment">
          here</v-btn
        >
        to add a payment method.
      </v-alert>
      <v-card-text>
        <h1 class="black--text font-weight-medium mb-1">
          {{ this.schoolName }}
        </h1>
        <p>{{ this.address }}</p>
        <p>
          {{ this.packageDetails }}
        </p>
        <v-row class="align-center">
          <v-col cols="auto" class="ml-auto">
            <h3>${{ this.price }}</h3>
          </v-col>
          <v-col cols="auto">
            <v-btn
              color="primary"
              large
              @click="enrol"
              :loading="loading"
              :disabled="!paymentMethodAdded"
            >
              Enrol
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <h3 class="white--text mt-6">Instructors who work for this school</h3>
    <InstructorCard
      v-for="instructor in instructors"
      :key="instructor.id"
      :instructor="instructor"
      :option="option"
      :showModal="false"
    />
  </div>
</template>

<script>
import Parse from 'parse'
import { mapActions, mapGetters } from 'vuex'
import InstructorCard from '@/components/student/InstructorCard'

export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      paymentMethodAdded: false,
      schoolStripeAccountId: '',
      schoolName: '',
      address: '',
      packageDetails: '',
      price: null,
      instructors: [],
      option: 'booking_lesson',
      schoolId: null,
      schoolUserId: null,
      schoolPackageJoinedId: null,
      schoolSubscriptionType: null
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'schoolPackage',
      'schoolInstructors',
      'schoolPackageJoined',
      'paymenthistory',
      'schoolPackageJoinedUpdate'
    ])
  },
  methods: {
    ...mapActions([
      'getSchoolPackageFromId',
      'toggleDialog',
      'getSchoolInstructors',
      'addSchoolPackage',
      'addPayentHistory',
      'updateSchoolPackage'
    ]),
    async enrol () {
      /** First save schoolPackages Joined with status false, then charge, on success, save payment history and then update schoolPackageJoined to true */
      const self = this
      if (
        self.id &&
        self.schoolId &&
        self.user.id &&
        self.schoolStripeAccountId
      ) {
        self.loading = true
        await self.addSchoolPackage({
          schoolPackageId: self.id,
          studentId: self.user.id,
          schoolId: self.schoolId
        })
        if (self.schoolPackageJoined) {
          this.schoolPackageJoinedId = self.schoolPackageJoined
          /** Now that we have 2 options, i.e it can be either percentage or stripe payment. If percentage, it should go under commission here */
          // const commission =
          //   self.schoolSubscriptionType === 'percentage' ? 20 : 0
          const commission = 0
          /** Charge now */
          var mData = {
            amount: Number(self.price) * 100,
            fee: Number(commission * 100),
            ownerAccountId: self.schoolStripeAccountId,
            customerId: self.user.get('stripeCustomerId'),
            paymentMethodId: self.user.get('stripePaymentMethodId'),
            offSeason: false
          }
          Parse.Cloud.run('chargeCardForSchoolPackage', mData).then(
            function (results) {
              if (results.status === 'succeeded') {
                /** Add to payment history table now */
                self.addPayentHistory({
                  senderId: self.user.id,
                  receiverId: self.schoolUserId,
                  amount: Number(self.price),
                  associaatedId: self.id,
                  stripePaymentId: results.id,
                  notes: 'School package added',
                  type: 'school_package'
                })

                /** Update the original joined table */
                self.updateSchoolPackage({
                  id: self.schoolPackageJoinedId
                })
                self.loading = false

                self.toggleDialog({
                  status: true,
                  title: 'Success',
                  message: 'Thank you! Your payment was successful'
                })
                setTimeout(function () {
                  /** redirect to payment page */
                  self.$router.push('/student-dashboard')
                }, 3000)
              }
            },
            (error) => {
              console.log(error)
              self.loading = false
              self.toggleDialog({
                status: true,
                title: 'Error',
                message: 'Something went wrong, please try again'
              })
            }
          )
        } else {
          this.loading = false
          this.toggleDialog({
            status: true,
            title: 'Error',
            message: 'Something went wrong, please try again'
          })
        }
      }
    }
  },
  components: {
    InstructorCard
  },
  async created () {
    // You can find package with id
    if (this.id) {
      /** Did he/she added the payment method? */
      if (this.user.get('stripePaymentMethodAdded')) {
        this.paymentMethodAdded = true
      }

      await this.getSchoolPackageFromId({
        schoolPackageId: this.id
      })

      if (!this.schoolPackage) {
        this.toggleDialog({
          status: true,
          title: 'Error',
          message: 'Something went wrong, please try again'
        })
        return
      }
      if (this.schoolPackage.get('schoolId')) {
        this.schoolStripeAccountId = this.schoolPackage
          .get('schoolId')
          .get('associatedId')
          .get('stripeUserAccountId')
        this.schoolSubscriptionType = this.schoolPackage
          .get('schoolId')
          .get('associatedId')
          .get('schoolSubscriptionType')

        this.schoolName = this.schoolPackage.get('schoolId').get('name')
        this.address =
          this.schoolPackage.get('schoolId').get('addressTwo') +
          ', ' +
          this.schoolPackage.get('schoolId').get('city') +
          ', ' +
          this.schoolPackage.get('schoolId').get('province')
        this.packageDetails = this.schoolPackage.get('packageDetails')
        this.price = this.schoolPackage.get('price')

        /** Get the list of school instructors who are associated with the school */
        this.schoolUserId = this.schoolPackage
          .get('schoolId')
          .get('associatedId').id
        if (this.schoolPackage.get('schoolId').id) {
          this.schoolId = this.schoolPackage.get('schoolId').id
          await this.getSchoolInstructors({
            schoolId: this.schoolPackage.get('schoolId').id
          })
          this.instructors = this.schoolInstructors
        }
      }
    } else {
      this.toggleDialog({
        status: true,
        title: 'Error',
        message: 'Something went wrong, please try again'
      })
    }
  }
}
</script>
